// extracted by mini-css-extract-plugin
export default {"container":"search_container__f6HZ5","loading":"search_loading__+xios","spin":"search_spin__h-FLk","input":"search_input__gqanI","iconOff":"search_iconOff__LzilA"};